$(function () {
  var $backTop = $('.backtop');

  if (!$backTop.length) return

  $backTop.on('click', function (e) {

    $('html, body').animate({
      scrollTop: $('body').offset().top
    }, 600);
  });
});



document.addEventListener("DOMContentLoaded", function () {
    var animated = false;

    var observer = new IntersectionObserver(function(entries, observer) {
        for (var i = 0; i < entries.length; i++) {
            var entry = entries[i];
            if (entry.isIntersecting && !animated) {
                animated = true;
                animateCounters();
                observer.unobserve(entry.target);
            }
        }
    }, { threshold: 0.4 });

    var target = document.querySelector('.sec-result');
    if (target) {
        observer.observe(target);
    }

    function animateCounters() {
        var counters = document.querySelectorAll(".card-number_big");

        for (var i = 0; i < counters.length; i++) {
            (function(counter) {
                var fullText = counter.textContent.trim();
                var finalValue = parseInt(fullText.replace(/\D/g, '')) || 0;
                var suffix = fullText.replace(/[0-9]/g, '');
                var current = 0;

                var duration = 1000; // duração total
                var frames = 60;
                var increment = Math.ceil(finalValue / frames);
                var stepTime = Math.floor(duration / frames);

                var interval = setInterval(function () {
                    current += increment;
                    if (current >= finalValue) {
                        current = finalValue;
                        clearInterval(interval);
                    }
                    counter.textContent = current.toLocaleString('pt-BR') + suffix;
                }, stepTime);
            })(counters[i]);
        }
    }
});